/**
 * Shared Splide accessibility helpers.
 * Unique labels fix duplicate unlabeled landmarks; stripping role="group"
 * from slides avoids axe aria-allowed-role on Splide 4 markup.
 */
export function splideA11yOptions(label) {
    return {
        label,
        live: false,
    };
}

export function fixSplideSlideRoles(splide) {
    const removeInvalidRoles = () => {
        splide.root.querySelectorAll('.splide__slide[role="group"]').forEach((slide) => {
            slide.removeAttribute('role');
        });
    };

    splide.on('mounted', removeInvalidRoles);
    splide.on('updated', removeInvalidRoles);
}
